import { render } from "./monthly-sub.vue?vue&type=template&id=462cf654"
import script from "./monthly-sub.vue?vue&type=script&lang=js"
export * from "./monthly-sub.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__